<template>
    <div>
        <div id="page">
            <div class="page-content">
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style text-center" style="margin-top:50px">
                    <div class="content pb-2">
                        <!--status==1 : Admin-->
                        <!--status==0 : User-->
                        <!--isFreeVersion==true : bazaar | myket-->
                        <div class="mb-5">
                            <i class="fa fa-exclamation-triangle color-red1-dark fa-5x pt-3 icon-size"></i>
                        </div>
                        <div class="status-1">
                            <div v-if="isFreeVersion==true && (status==1 || status==0 || status==null)">
                                <!--<p>isFree Version Admin : Bazzar</p>-->
                                <p>
                                    جهت استفاده از تمامی امکانات
                                    <span v-if="isKarnegasht==true">کارنگاشت </span>
                                    <span v-if="isKarnegasht==false">تسکینو </span>
                                    ، می بایست
                                    <b class="text-danger">اشتراک فعال</b>

                                    داشته باشید .در صورت عدم خرید اشتراک
                                    <b class="text-warning">برخی از امکانات</b>
                                    برای شما فعال نمی باشد.
                                </p>
                                <p v-html="taskOnlinePayForFreeMessage" class="pb-4">

                                </p>
                            </div>

                            <div v-if="isFreeVersion==false">
                                <!--<p>is not Free Version Admin : Bazzar nist</p>-->
                                <p>
                                    جهت استفاده از تمامی امکانات
                                    <span v-if="isKarnegasht==true">کارنگاشت </span>
                                    <span v-if="isKarnegasht==false">تسکینو </span>
                                    ، می بایست
                                    <b class="text-danger">اشتراک فعال</b>

                                    داشته باشید .در صورت عدم خرید اشتراک
                                    <b class="text-warning">برخی از امکانات</b>
                                    برای شما فعال نمی باشد.
                                </p>
                                <div class="row mb-0" v-if="isAdmin==true">
                                    <div class="col-12">
                                        <a href="/Order" class="btn btn-m btn-full rounded-s shadow-xl font-900 bg-highlight add-button">
                                            <i class="fa fa-user-clock ml-2"></i>
                                            خرید اشتراک
                                        </a>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="status-2" v-if="status==2">
                            <p class="text-danger"><b>کاربر گرامی، حساب کاربری شما توسط سرپرست تیم غیرفعال شده است.</b></p>
                        </div>


                        <div class="row mt-3">
                            <div class="col-12">
                                <a href="/" class="btn btn-m btn-full rounded-s shadow-xl font-900 bg-green1-light add-button">
                                    <i class="fa fa-redo ml-2"></i>
                                    بازگشت به صفحه اصلی
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-success w-100 btn-m btn-full rounded-s shadow-xl font-900 add-button" v-on:click="CheckIsEnable()">
                                    <i class="fa fa-search ml-2"></i>
                                    بررسی مجدد
                                </button>
                            </div>
                        </div>
                        <div class="row mb-0">
                            <div class="col-12">
                                <button class="btn btn-outline-danger w-100 btn-m btn-full rounded-s shadow-xl font-900 add-button" @click.prevent="SignOutUser()">
                                    <i class="fa fa-sign-out-alt ml-2"></i>
                                    خروج از حساب کاربری
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showInBazar: false,
                info: null,
                status: this.$route.params.adminOrUser,
                taskOnlinePayForFreeMessage: ""
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters.GetIsAdmin;
            },

        },
        created() {
            //this.$http
            //    .get("Task/GetPayInBazarAllowAnonymous")
            //    .then((data) => {
            //        var res = data.data;
            //        this.showInBazar = res.isSuccess;
            //    });
            this.$http
                .get("TaskOnline/GetTaskOnlinePayForFreeMessage")
                .then((data) => {
                    this.taskOnlinePayForFreeMessage = data.data;
                });
        },
        methods: {
            CheckIsEnable() {
                console.log("log");
                window.location = "/";
            },
            SignOutUser() {
                this.$store.dispatch("SignOutUser");
            },
        }
    }
</script>
